// removed by extract-text-webpack-plugin
module.exports = {"flexContent":"_1Sgi82upEWjiWoG86c67c3 undefined"};